import { i18n, i18nExists } from 'src/i18n';

export function usageLogTypeLabel(value) {
  if (!value) {
    return null;
  }

  const directKey = `entities.usageLog.enumerators.type.${value}`;

  if (i18nExists(directKey)) {
    return i18n(directKey);
  }

  const normalizedValue = String(value).toUpperCase();
  const normalizedKey = `entities.usageLog.enumerators.type.${normalizedValue}`;

  if (i18nExists(normalizedKey)) {
    return i18n(normalizedKey);
  }

  return String(value)
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}
